// extracted by mini-css-extract-plugin
export default {"wrapper":"VXnSULRFGNG2AouH_5nE"};